import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss']
})
export class ContactInformationComponent implements OnInit {

  formGroup: FormGroup;
  @Output() onCreateForm: EventEmitter<FormGroup>;

  constructor(fb: FormBuilder) {
    this.formGroup = fb.group({
      firstName: new FormControl("", [Validators.required]),
      lastName: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, this.emailValidator]),
      phone: new FormControl("", [Validators.required, this.phoneValidator]),
      ext: new FormControl("")
    });

    this.onCreateForm = new EventEmitter<FormGroup>();
  }

  ngOnInit() {
    this.onCreateForm.emit(this.formGroup);
  }

  emailValidator(control: FormControl): { [s: string]: boolean } {

    const EMAIL_REGEX: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (control.value && !EMAIL_REGEX.test(control.value)) {
      return {'Please enter a valid email': true};
    }

    const res = Validators.email(control);
    if(res && res.hasOwnProperty('email')) {
      return {'Please enter a valid email': true};
    }
    
    if(control.value.toLowerCase().includes("@datafinch")) {
      return {"Datafinch emails are not valid.": true};
    }
  }

  
  phoneValidator(control: FormControl): { [s: string]: boolean } {
    if(control.value.length > 0) {
      var number = control.value.replace(/\D/g, '');
      if (!number || (number.length < 10 || number.length > 15)) {
        return {'Phone number must be valid': true};
      }
    }
  }

  limitPhoneChars(control: FormControl) {
    if(control instanceof FormControl) {
      control.setValue(control.value.replace(/[^0-9.,)(-]+/, ""));
    }
  }

}
